import React, { useState, useContext } from 'react';
import { Button } from '@agconnections/grow-ui';
import { Redirect } from 'react-router-dom';
import backgroundImage from 'assets/login-background.jpg';
import cmeGroupmage from 'assets/cme-group.svg';
import cropwiseBrandLogo from 'assets/cropwise-financials-logo.svg';
import { useFlags } from 'launchdarkly-react-client-sdk';
import MaintenanceLandingComponent from './MaintenanceLandingComponent';
import { AmplitudeContext } from '../../utilities/amplitude/useAmplitude';

const Landing = () => {
  // const history = useHistory();
  const [redirect, setRedirect] = useState();
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const { events, sendEventToAmplitude } = useContext(AmplitudeContext);
  const {
    feLandManagementUndergoingMaintenanceMessaging: maintenanceLandingFF
  } = useFlags();

  return (
    <div>
      {redirect && <Redirect push to={`${redirect}`} />}
      <div className="fixed right-0 w-2/3 h-screen">
        <img
          src={backgroundImage}
          alt=""
          className="absolute inset-0 object-cover w-full h-screen"
        />
        <div className="absolute inset-0 flex justify-center items-center px-16 py-8">
          <div className="w-full relative">
            {!iframeLoaded && (
              <div
                className="absolute inset-0 flex justify-center items-center bg-white rounded-lg shadow-lg"
                style={{ height: '450px' }}
              >
                <div className="flex flex-col items-center">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600" />
                  <p className="mt-4 text-gray-600">
                    Loading Market Snapshot...
                  </p>
                </div>
              </div>
            )}
            <img
              src={cmeGroupmage}
              alt="CME Group"
              className="absolute top-5 right-4 z-10"
            />
            <iframe
              src="https://syngenta.websol.barchart.com/?module=marketSnapshot"
              title="Market Snapshot"
              className="w-full border-0 rounded-lg shadow-lg"
              style={{ height: '430px', opacity: iframeLoaded ? 1 : 0 }}
              onLoad={() => setIframeLoaded(true)}
            />
            {/* White overlay to cover CME logo at bottom of iframe */}
            <div className="absolute bottom-0 h-16 left-0 right-0 bg-white rounded-lg z-10" />
          </div>
        </div>
        {/* <div className="fixed bottom-0 right-0">
          <div
            className="font-medium uppercase text-white mix-blend-normal"
            style={{
              font: 'rubik',
              fontSize: '210px',
              lineHeight: '137px',
              letterSpacing: '-13.83px',
              opacity: '0.2'
            }}
          >
            Wel
          </div>
          <div
            className="font-medium uppercase text-white mix-blend-normal"
            style={{
              font: 'rubik',
              fontSize: '210px',
              lineHeight: '137px',
              letterSpacing: '-13.83px',
              opacity: '0.2',
              paddingLeft: '9%',
              marginTop: '3%'
            }}
          >
            come
          </div>
        </div> */}
      </div>
      <div className="w-1/3 h-screen">
        <div className="flex justify-center items-center h-screen">
          <div className="relative flex flex-col items-center justify-center pl-6 md:items-start">
            <img
              src={cropwiseBrandLogo}
              alt="CropWise Logo"
              className="block mb-12 md:inline"
            />
            <div className="flex w-full justify-center">
              <div className="flex flex-wrap">
                <Button
                  type="primary"
                  disabled={maintenanceLandingFF !== ''}
                  onClick={() => {
                    // amplitude trigger
                    sendEventToAmplitude(events.epic.Authentication.signIn);
                    setRedirect('/login');
                  }}
                >
                  Sign In
                </Button>
                <div className="ml-4">
                  <Button
                    type="primary"
                    disabled={maintenanceLandingFF !== ''}
                    onClick={() =>
                      (window.location.href =
                        "https://staging.accounts.cropwise.com/signup?source_campaign=M2FlN2VjM2ItNjVjMy00YzA5LTk4MWItMzEzOTc5ODZjYzIzOjoyNmRlYWQ0ZS1mNjVmLTQwYmUtOGEzMC02NDZiYWNjYjhlY2M6OkNyb3BXaXNl&redirect_uri=https://qa.financials.cropwise.com/authenticate&client_id=ddcd4fe8157148fc90b0fe95753f2bd0")
                    }
                  >
                    Sign Up
                  </Button>
                </div>
              </div>
            </div>
            {maintenanceLandingFF && maintenanceLandingFF !== '' && (
              <MaintenanceLandingComponent
                featureFlagText={maintenanceLandingFF}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;

// <div className="fixed top-0 right-0 z-50 w-full h-screen">
//   {redirect && <Redirect push to={`${redirect}`} />}
//   <a href="https://staging.accounts.cropwise.com/signup?source_campaign=M2FlN2VjM2ItNjVjMy00YzA5LTk4MWItMzEzOTc5ODZjYzIzOjoyNmRlYWQ0ZS1mNjVmLTQwYmUtOGEzMC02NDZiYWNjYjhlY2M6OkNyb3BXaXNl">
//     Sign Up
//   </a>
//   <Button
//     onClick={() => {
//       setRedirect('/login');
//     }}
//   >
//     Sign In
//   </Button>
// </div>
